export const regularCta = {
  fontSize: "16px",
  marginTop: "0",
  fontFamily: "var(--font-brandon-grotesque)",
  fontWeight: 700,
  textTransform: "none",
  backgroundColor: "#095a70",
  marginBottom: "0px",
  lineHeight: "16px",
  display: "flex",
  boxShadow: "none",
  padding: "8px 30px",

  "&:hover": {
    backgroundColor: "#00acc1",
  },

  "a, a:hover, a:visited, a:active": {
    color: "white",
  },
};
